import React from 'react';
import './App.css';
import ClientPortalRouter from './routes/router';
import { AuthProvider } from './context/AuthProvider';
import { ConfigProvider } from 'antd';
import { getTheme } from './styles/theme';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ConfigProvider theme={getTheme() as any} wave={{disabled: true}}>
          <ClientPortalRouter />
        </ConfigProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
